import { getWithHeaders } from "./AureaApi";
import { FeatureCollection, Point } from "geojson";
import { GetFieldParams } from "./route-params.types";

export type TreePositions = FeatureCollection<Point>;

export type FieldTrees = {
  positions: TreePositions;
  lastModified: string | null;
};

export async function getFieldTrees({
  params: { fieldId },
}: GetFieldParams): Promise<FieldTrees> {
  const { data, headers } = await getWithHeaders<TreePositions>(
    `/v1/field/${fieldId}/tree/geojson`,
  );
  return { positions: data, lastModified: headers.get("Last-Modified") };
}
